import { P360Card } from 'legacy/lut/components/widgets/public/partner360/p360Card'
import { useMemo } from 'react'

import { RenderWhen } from 'cng-common/components/renderWhen'
import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { Flex } from 'core-components/library/flex'
import {
  AbsolutePopup,
  TPopupHorizontal,
  TPopupVertical,
  TVisibilityTrigger,
} from 'core-components/library/popup'
import { CurrenciesButtons } from 'partner360/components/currenciesButtons'
import { DashboardLabel } from 'partner360/features/keyInitiatives/ui/common/dashboardLabel/DashboardLabel'

import { MDF_ACTIVITIES_TRANSLATION_KEYS } from '../../configs/translations'
import { useMdfDashboardFiltersForm } from '../../hooks/useMdfDashboardFiltersForm'
import { MdfActivitiesRefreshButton } from '../mdfActivitiesRefreshButton'

import { MdfDashboardFiltersPopup } from './MdfDashboardFiltersPopup'

import styles from './MdfDashboardFilters.module.scss'

const KEYS = MDF_ACTIVITIES_TRANSLATION_KEYS

interface IMdfDashboardFiltersProps {
  partnerId: string
}

export const MdfDashboardFilters = ({ partnerId }: IMdfDashboardFiltersProps) => {
  const {
    strategicInitiativesFilterValue,
    businessPrioritiesFilterValue,
    timeframesFilterValue,
    changeStrategicInitiatives,
    changeBusinessPriorities,
    changeTimeframes,
    resetFormData,
  } = useMdfDashboardFiltersForm()

  const appliedFilterBubbles = useMemo(() => {
    return [
      {
        label: KEYS.dashboard.filters.strategicInitiativeBubble,
        count: strategicInitiativesFilterValue?.length,
        onRemove: () => changeStrategicInitiatives([]),
      },
      {
        label: KEYS.dashboard.filters.businessPriorityBubble,
        count: businessPrioritiesFilterValue?.length,
        onRemove: () => changeBusinessPriorities([]),
      },
      {
        label: KEYS.dashboard.filters.timeframeBubble,
        count: timeframesFilterValue?.length,
        onRemove: () => changeTimeframes([]),
      },
    ].filter((item) => Boolean(item.count))
  }, [
    strategicInitiativesFilterValue?.length,
    businessPrioritiesFilterValue?.length,
    timeframesFilterValue?.length,
    changeStrategicInitiatives,
    changeBusinessPriorities,
    changeTimeframes,
  ])

  const appliedFiltersCount = appliedFilterBubbles.length

  const clearAllFilters = () => {
    resetFormData()
  }

  return (
    <P360Card className={styles.root}>
      <div className={styles.toolbar}>
        <div className={styles.filtersSide}>
          <AbsolutePopup
            rootClassName={styles.popupRoot}
            horizontalDirection={TPopupHorizontal.Left}
            verticalDirection={TPopupVertical.Bottom}
            horizontalStartPosition={TPopupHorizontal.Right}
            verticalStartPosition={TPopupVertical.Bottom}
            visibilityTrigger={TVisibilityTrigger.Click}
            popupContent={({ action }) => <MdfDashboardFiltersPopup onClose={action.close} />}
          >
            <Button variant={'outlined'} color={'grey'} className={styles.btn}>
              <Flex alignItems={'center'}>
                <i className={'kbase kbase-nakb-menu'} />
                <Translation text={KEYS.dashboard.filters.title} />
                {appliedFiltersCount ? (
                  <div className={styles.filterCount}>{appliedFiltersCount}</div>
                ) : null}
              </Flex>
            </Button>
          </AbsolutePopup>

          {appliedFilterBubbles.map(({ label, count, onRemove }) => (
            <Button
              key={label}
              variant={'custom'}
              className={styles.filterBubble}
              onClick={onRemove}
              icon="kbase kbase-close"
              iconPosition="end"
            >
              <Translation
                text={label}
                replaceParams={[{ key: '{count}', value: String(count) }]}
              />
              {/* <i className={cn(styles.filterBubbleClose, 'kbase kbase-close')} /> */}
            </Button>
          ))}

          <RenderWhen condition={Boolean(appliedFilterBubbles.length)}>
            <Button variant={'text'} color={'grey'} size={'sm'} onClick={clearAllFilters}>
              <Translation text={KEYS.dashboard.filters.resetBubble} />
            </Button>
          </RenderWhen>
        </div>

        <div className={styles.controlsSide}>
          <MdfActivitiesRefreshButton partnerId={partnerId} />

          <div className={styles.columnField}>
            <DashboardLabel translationKey={KEYS.dashboard.filters.currency} />
            <CurrenciesButtons size="small" />
          </div>
        </div>
      </div>
    </P360Card>
  )
}
